export default "__VITE_ASSET__BRBO88mn__"